import React, { Component } from "react";
import { Table } from "semantic-ui-react";
import _ from "lodash";
import { getDate, getDobDate } from "../../common/DisplayDate";
import getSsn from "../../common/Ssn";
import getPersonName from "../../common/Name";
import SimpleAccordionContent from "../../common/SimpleAccordionContent";

class Imposters extends Component {
  constructor(props) {
    super(props);
    this.state = {
      rows: [],
      savedResultID: "",
      internalID: "",
    };
  }

  componentWillReceiveProps(nextProps) {
    const { internalID, savedResultID } = nextProps.additionalData;
    if (
      this.state.internalID !== internalID ||
      this.state.savedResultID !== savedResultID
    ) {
      this.setState({ internalID, savedResultID });
      this.loadData(nextProps);
    }
  }

  loadData = (props) => {
    const rows = [];
    let recCount = 0;
    if (props.reportData !== undefined) {
      const imposters = _.get(
        props.reportData,
        "personReport.compReportResponse[0].individual[0].imposters[0].imposter"
      );
      if (imposters && imposters.length > 0) {
        _.forEach(imposters, (record, index) => {
          const identities = _.get(record, "AKAs[0].identity");
          const imposterRows = [];
          _.forEach(identities, (identity, identityIndex) => {
            const DOB = getDobDate(_.get(identity, "DOB[0]"), {
              userAccount: this.props.userAccount,
            });

            const issuedEndDate = getDate(
              _.get(identity, "SSNInfo[0].issuedEndDate[0]")
            );

            const issuedStartDate = getDate(
              _.get(identity, "SSNInfo[0].issuedStartDate[0]")
            );

            imposterRows.push(
              <Table.Row
                key={`rep_liens_row_3_${index}_${identityIndex}`}
                className={identityIndex % 2 === 1 ? "table-row-odd-child" : ""}
              >
                <Table.Cell className="text-bold">Name:</Table.Cell>
                <Table.Cell>
                  {getPersonName(
                    _.get(identity, "name[0].first[0]._", ""),
                    "",
                    _.get(identity, "name[0].last[0]._", ""),
                    props
                  )}
                </Table.Cell>

                <Table.Cell className="text-bold">DOB:</Table.Cell>
                <Table.Cell> {DOB} </Table.Cell>

                <Table.Cell className="text-bold">SSN:</Table.Cell>
                <Table.Cell>
                  {getSsn(_.get(identity, "SSNInfo[0].SSN[0]._"), this.props)}
                </Table.Cell>

                <Table.Cell className="text-bold"> Years Issued: </Table.Cell>
                <Table.Cell>
                  {issuedStartDate} - {issuedEndDate}
                </Table.Cell>
              </Table.Row>
            );
          });
          rows.push(
            <Table.Row key={`imp_iden_row_${index}`}>
              <Table.Cell>
                <Table>
                  <Table.Body>
                    <Table.Row key={`imp_iden_row_title_${index}`}>
                      <Table.HeaderCell
                        className="report-sub-section-header text-center"
                        colSpan={8}
                      >
                        Imposter
                      </Table.HeaderCell>
                    </Table.Row>
                    {imposterRows}
                  </Table.Body>
                </Table>
              </Table.Cell>
            </Table.Row>
          );
        });
        recCount = rows.length;
      } else {
        rows.push(
          <Table.Row key={`no_recs_row`}>
            <Table.Cell colSpan={2}>No Records found</Table.Cell>
          </Table.Row>
        );
      }
    } else {
      rows.push(
        <Table.Row key={`no_recs_row`}>
          <Table.Cell colSpan={2}>No Records found</Table.Cell>
        </Table.Row>
      );
    }
    this.setState({ rows });
    props.updateItemCountBySection(props.sectionName, recCount);
  };

  render() {
    return (
      <SimpleAccordionContent
        {...this.props}
        name={"Imposters"}
        rows={this.state.rows}
      />
    );
  }
}

export default Imposters;



// WEBPACK FOOTER //
// ./src/components/reports/Platinum/Imposters.js